/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentDocumentType } from './FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentDocumentType';
import {
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentDocumentTypeFromJSON,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentDocumentTypeFromJSONTyped,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentDocumentTypeToJSON,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentDocumentTypeToJSONTyped,
} from './FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentDocumentType';

/**
 * 
 * @export
 * @interface FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocument
 */
export interface FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocument {
    /**
     * Идентификатор документа.
     * @type {number}
     * @memberof FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocument
     */
    Id: number;
    /**
     * 
     * @type {FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentDocumentType}
     * @memberof FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocument
     */
    DocumentType: FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentDocumentType;
    /**
     * Дата и время создания документа.
     * @type {Date}
     * @memberof FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocument
     */
    CreatedAt: Date;
    /**
     * Признак того, что документ активен и может использоваться.
     * @type {boolean}
     * @memberof FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocument
     */
    IsActive: boolean;
    /**
     * Игра, к которой относится документ.
     * @type {string}
     * @memberof FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocument
     */
    GameSystemName: string;
    /**
     * Ссылка на API для принятия документа.
     * @type {string}
     * @memberof FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocument
     */
    AcceptDocumentUrl?: string | null;
    /**
     * Ссылка на просмотр документа.
     * @type {string}
     * @memberof FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocument
     */
    WebDocumentUrl: string;
}

/**
 * Check if a given object implements the FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocument interface.
 */
export function instanceOfFxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocument(value: object): value is FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocument {
    if (!('Id' in value) || value['Id'] === undefined) return false;
    if (!('DocumentType' in value) || value['DocumentType'] === undefined) return false;
    if (!('CreatedAt' in value) || value['CreatedAt'] === undefined) return false;
    if (!('IsActive' in value) || value['IsActive'] === undefined) return false;
    if (!('GameSystemName' in value) || value['GameSystemName'] === undefined) return false;
    if (!('WebDocumentUrl' in value) || value['WebDocumentUrl'] === undefined) return false;
    return true;
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentFromJSON(json: any): FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocument {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentFromJSONTyped(json, false);
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocument {
    if (json == null) {
        return json;
    }
    return {
        
        'Id': json['Id'],
        'DocumentType': FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentDocumentTypeFromJSON(json['DocumentType']),
        'CreatedAt': (new Date(json['CreatedAt'])),
        'IsActive': json['IsActive'],
        'GameSystemName': json['GameSystemName'],
        'AcceptDocumentUrl': json['AcceptDocumentUrl'] == null ? undefined : json['AcceptDocumentUrl'],
        'WebDocumentUrl': json['WebDocumentUrl'],
    };
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentToJSON(json: any): FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocument {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentToJSONTyped(json, false);
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentToJSONTyped(value?: FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocument | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Id': value['Id'],
        'DocumentType': FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentDocumentTypeToJSON(value['DocumentType']),
        'CreatedAt': ((value['CreatedAt']).toISOString()),
        'IsActive': value['IsActive'],
        'GameSystemName': value['GameSystemName'],
        'AcceptDocumentUrl': value['AcceptDocumentUrl'],
        'WebDocumentUrl': value['WebDocumentUrl'],
    };
}

